<template>
  <div
    :style="{ backgroundColor: props.value }"
    :class="[
      'h-6 w-6 flex-shrink-0',
      rounded ? 'rounded-full' : 'rounded-lg',
    ]"
  />
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{ value?: string; rounded?: boolean }>(),
  { value: undefined, rounded: false }
)
</script>
